import { uuid } from '@elfsight/lib-utils';

export const commonDefaultSettings = {
  width: 100,
  presetWidth: 100,
  required: false,
  showLabel: true,
  hasConditionalLogic: false,
  conditionalLogic: {
    action: 'show',
    operator: 'AND'
  } as const,
  conditions: [
    {
      fieldID: '',
      condition: undefined,
      value: '',
      id: uuid()
    }
  ]
};
